import React from 'react';

import createSvgIcon from './hoc/createSvgIcon';

export default createSvgIcon(
  () => (
    <>
      <rect x="3" y="4" width="3" height="15" fill="black" fillOpacity="0.6" />
      <rect x="9" y="4" width="3" height="15" fill="black" fillOpacity="0.6" />
      <rect x="6" y="10" width="3" height="3" fill="black" fillOpacity="0.6" />
      <path
        d="M21 19V16H17V13H18C18.7956 13 19.5587 12.6839 20.1213 12.1213C20.6839 11.5587 21 10.7956 21 10V7C21 6.20435 20.6839 5.44129 20.1213 4.87868C19.5587 4.31607 18.7956 4 18 4H14V7H18V10H17C16.2044 10 15.4413 10.3161 14.8787 10.8787C14.3161 11.4413 14 12.2044 14 13V19H21Z"
        fill="black"
        fillOpacity="0.6"
      />
    </>
  ),
  'Heading 2',
  '0 0 24 24'
);
